import axios from "axios";

//atesfa
const dataRequest = axios.create({  
    //baseURL: 'https://localhost:6900/api/',
    baseURL: 'http://calendar.ttfnsite.com/api/api/',
    headers: {
      Authorization: `Bearer ${JSON.parse(localStorage.getItem('token'))}` // Bearer 跟 token 中間有一個空格
    }
})

dataRequest.interceptors.response.use(
response => response,
error => {
    if (error.response.status === 401) {
        localStorage.removeItem("token");
    }
});

export const userLogin = 
    data => dataRequest.post('/user/Login', data);

export const AddAccount = 
    data => dataRequest.post('/user/CreateAccount', data);
  
export const GetCanendar = 
    () => dataRequest.get('/calendar/GetCanendar');

export const AddJourney =
    data => dataRequest.post('/calendar/AddJourney', data);

export const GetJourney = 
    () => dataRequest.get('/calendar/Getjourney');

export const GetFinance = 
    () => dataRequest.get('/calendar/GetFinance');

export const AddFinance = 
    data => dataRequest.post('/calendar/AddFinance', data);

export const DeleteFinance = 
    data => dataRequest.delete('calendar/DeleteFinance', data);

export const UpdateTodoList = 
    data => dataRequest.put('calendar/UpdateTodoList', data);

export const AddTodoList = 
    data => dataRequest.post('calendar/AddTodoList', data);

export const AddMemorial =
    data => dataRequest.post('calendar/AddMemorial', data);

export const AddDailyCheckList = 
    data => dataRequest.post('calendar/AddDailyCheckList', data);

export const GetDailyCheck =
    data => dataRequest.get('calendar/GetDailyCheck');

export const UpdateDailyCheck =
    data => dataRequest.put('calendar/UpdateDailyCheck', data);

export const AddUserMC = 
    data => dataRequest.post('calendar/AddUserMC', data);

export const GetUserMCHistory = 
    () => dataRequest.get('calendar/GetUserMCHistory');

export const DeleteUserMC = 
    data => dataRequest.delete('calendar/DeleteUserMCHistory', data);


export const cdata = () => {
    let data = [
        {
            year: 1988,
            month: 9,
            day: 27,
            title: "",
            type: "",
            selected: false,
        }
    ];
    
    return data;
}